import { browserHistory } from 'react-router';
import service from '../utils/axios';
import { API_URL } from '../const/const';

const ANSWER_URL = '/answer';

export function sliderChanged(answers, id, evalId, value) {
  return {
    type: 'SLIDER_CHANGED',
    answers,
    id,
    eval: evalId,
    value,
  };
}

export function sliderLocked(answers, statement_id, evalId) {
  return {
    type: 'SLIDER_LOCKED',
    answers,
    id: statement_id,
    eval: evalId,
  };
}

export function saveAnswers(answers, evalId) {
  return {
    type: 'SAVE_ANSWERS',
    answers,
    eval: evalId,
  };
}

export function sendingAnswers() {
  return {
    type: 'SENDING_ANSWERS',
  };
}

export function sendingAnswersLastPage() {
  return {
    type: 'SENDING_ANSWERS_LAST_PAGE',
  };
}

export function sentAnswers() {
  return {
    type: 'SENT_ANSWERS',
  };
}

export function sentAnswersLastPage() {
  return {
    type: 'SENT_ANSWERS_LAST_PAGE',
  };
}

export function postAnswers(answerData, nextLink) {
  return post(answerData, `${API_URL}${ANSWER_URL}`, nextLink);
}

export function postTextAnswers(textAnswerData, nextLink, statusModal) {
  return post(textAnswerData, `${API_URL}${ANSWER_URL}/text`, nextLink, statusModal);
}

export function postCustomTextAnswers(textAnswerData, nextLink, statusModal) {
  return post(textAnswerData, `${API_URL}${ANSWER_URL}/customtext`, nextLink, statusModal);
}

function post(data, url, nextLink, statusModal) {
  return function (dispatch) {
    if (nextLink) {
      dispatch(sendingAnswers());
    } else {
      dispatch(sendingAnswersLastPage());
    }
    return service
      .post(url, data)
      .then(res => {
        if (res.data.success) {
          if (nextLink) {
            setTimeout(() => {
              dispatch(sentAnswers());
              browserHistory.push(nextLink);
            }, 300);
          } else {
            dispatch(sentAnswersLastPage());
            statusModal();
          }
        } else if (res.data.error) {
          setTimeout(() => {
            dispatch(sentAnswers());
            dispatch(savingError(res.data.error));
          }, 300);
        }
      })
      .catch(error => {
        setTimeout(() => {
          dispatch(sentAnswers());
          dispatch(savingError(error.message));
        }, 300);
      });
  };
}

export function savingError(error) {
  return {
    type: 'SAVE_ERROR',
    error,
  };
}

export function customTextChanged(value, evalId, questionId) {
  return {
    type: 'CUSTOM_TEXT_CHANGED',
    value,
    evalId,
    questionId,
  };
}

export function customTextCheckboxChanged(value, evalId, questionId) {
  return {
    type: 'CUSTOM_TEXT_CHECKBOX_CHANGED',
    value,
    evalId,
    questionId,
  };
}

export function textChanged(value, evalId) {
  return {
    type: 'TEXT_CHANGED',
    value,
    evalId,
  };
}

export function checkboxChanged(value, evalId) {
  return {
    type: 'CHECKBOX_CHANGED',
    value,
    evalId,
  };
}

export function textAnswerError(error) {
  return {
    type: 'TEXT_ANSWER_ERROR',
    error,
  };
}

export function toggleStatement(statementId, evalId, remainingPoints, availablePoints, answers) {
  return {
    type: 'TOGGLE_STATEMENT',
    statementId,
    evalId,
    remainingPoints,
    answers,
    availablePoints,
  };
}
